import * as Sentry from '@sentry/react'
import { isSemiosEmployeeOrTester } from 'utils/isSemiosEmployeeOrTester'
import { appInfo } from '../appInfo'

declare global {
  // eslint-disable-next-line local-rules/no-type-interfaces
  interface Window {
    _hsq?: Array<['identify', { email: string; id: string }]> // hubspot... just making it specific to how we use it for now.
  }
}

export const updateUserTrackers = (o: { email: string; userId: number }) => {
  const userIdForTrackers = isSemiosEmployeeOrTester() ? `employee-${o.userId}` : `customer-${o.userId}`

  if (appInfo.useSentry) {
    Sentry.setUser({ id: userIdForTrackers })
  }

  if (appInfo.useHubspot && Array.isArray(window._hsq)) {
    window._hsq.push(['identify', { id: userIdForTrackers, email: o.email }])
  }
}
